<bs-alert *msShowInEpcot="{ showInEpcot: false, module: module }" [type]="alertType" [message]="resultMessage()"></bs-alert>
<ms-epcot-notification
    *msShowInEpcot="{ showInEpcot: true, module: module }"
    [message]="resultMessage()"
    [notificationType]="'success'"></ms-epcot-notification>
